import React, { useMemo, useContext } from 'react';
import { createColors } from '../../shared/ui/theme/tokens/primitive-tokens/colors';
import GracePeriodContext from '../grace_period_context';
import { Link } from '../../shared/ui/navigations/link';

const brandColors = createColors(1).brand;

const GracePeriodBanner: React.FC = () => {
  const { gracePeriod } = useContext(GracePeriodContext);
  const styles = useMemo(() => getStyles(), []);

  if (!gracePeriod || gracePeriod.expired || gracePeriod.trial) return null;

  return (
    <div style={styles.banner}>
      <span style={styles.icon}>ⓘ</span>
      <div style={styles.body}>
        <p style={styles.bodyParagraph}>【重要なお知らせ】</p>
        <p style={styles.bodyParagraph}>平素より、AI Expenseをご利用いただき誠にありがとうございます。</p>
        <p style={styles.bodyParagraph}>
          この度、更なる機能拡充とサービス向上を目指し、{gracePeriod.deadline}
          より有料化いたします。
        </p>
        <p style={styles.bodyParagraph}>
          ご理解とご協力を賜りますようお願い申し上げます。
          <Link
            className="expenses-grace-period-banner__link"
            style={styles.link}
            href="/aiexpense/organization/plans"
          >
            プランのアップグレードはこちら
          </Link>
        </p>
      </div>
    </div>
  );
};

const getStyles = () => ({
  banner: {
    display: 'flex' as const,
    alignItems: 'flex-start' as const,
    gap: '10px',
    margin: '16px 24px',
    padding: '12px 16px',
    backgroundColor: '#fffdf0',
    border: '1px solid #c8a84b',
    borderRadius: '6px',
    fontSize: '1rem',
    color: '#333'
  },
  icon: {
    flexShrink: 0,
    fontSize: '16px',
    color: '#c8a84b',
    marginTop: '1px'
  },
  body: {
    display: 'flex' as const,
    flexDirection: 'column' as const,
    gap: '2px'
  },
  bodyParagraph: {
    margin: 0,
    lineHeight: 1.6
  },
  link: {
    fontSize: '1rem',
    marginTop: '4px',
    color: brandColors[500],
    textDecoration: 'underline' as const
  }
});

export default GracePeriodBanner;
